<template>
  <div class="xiaotaomama-wechat-wrapper" @touchmove.prevent.stop>
    <div
      v-if="show"
      class="main-wrapper">
      <div class="logo">
        <img src="https://img.taotonggroup.com/20200720100559d18206046.jpg" />
      </div>
      <div class="code">
        <img src="https://img.taotonggroup.com/202007201005591d3544920.jpg" />
      </div>
      <div class="text">长按识别二维码并关注公众号，已通过安全认证</div>
    </div>
  </div>
</template>

<script>
import { showMessageDialog, qsParams, searchObj, goGet } from '@/utils/public'
export default {
  data() {
    return {
      ajaxJson: {
        user_id: '',
        flag: 'person'
      },
      show: false,
      userCode: {}
    }
  },
  methods: {
    getUserId(value) {
      // 获取参数中的UserID
      let query = value || this.$route.query
      if (query.user_id) {
        this.ajaxJson.user_id = query.user_id
        this.getUserInfo()
      } else if (location.search.length) {
        let search = searchObj(location.search)
        this.getOpenID(search)
      } else {
        showMessageDialog({mesg: '没找到对应的用户信息,请联系客服'})
      }
    },
    getUserInfo() {
      // 获取用户信息
      let params = {
        appid: 'wxd4a43be65ae4f511',
        redirect_uri: encodeURI('https://xbi.taotonggroup.com/#/xiaotaomama/wechat'),
        response_type: 'code',
        scope: 'snsapi_userinfo',
        state: this.ajaxJson.user_id
      }
      location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?' + qsParams(params) + '#wechat_redirect'
    },
    getOpenID(search) {
      // 获取用户openID
      console.log(search)
      this.userCode = search
      goGet(
        process.env.VUE_APP_MALL_API + '/mall/v1/xtmm/unionid',
        {
          code: search.code,
          user_id: search.state
        }
      ).then(res => {
        console.log(res)
        if(res.code !== 200) {
          showMessageDialog({mesg: '系统繁忙，请稍后再试'})
        } else {
          this.show = true
        }
      })
    }
  },
  mounted() {
    this.getUserId()
  }
}
</script>

<style lang="scss" scoped>
.xiaotaomama-wechat-wrapper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-size: 100% auto;
  background: #f2f2f2;
  padding: 10px;
  .main-wrapper {
    width: 100%;
    background: #fff;
    overflow: hidden;
    .logo {
      width: 65px;
      height: 65px;
      overflow: hidden;
      border-radius: 50%;
      margin: 0 auto;
      margin-top: 20px;
      img {
        width: 100%;
      }
    }
    .code {
      width: 250px;
      height: 250px;
      border-radius: 10px;
      margin: 0 auto;
      margin-top: 10px;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .text {
      text-align: center;
      background: rgb(204, 255, 212);
      color: rgb(20, 162, 20);
      font-size: 12px;
      width: 300px;
      line-height: 30px;
      height: 30px;
      margin: 10px auto;
      margin-bottom: 20px;
      border-radius: 15px;
    }
  }
}
</style>
